import { Box, Tooltip } from "@mui/material";
import { GridEditInputCell } from "@mui/x-data-grid"; 
import { logDev } from "../utils/logger.js"

export const buildColumns = ({
  t,
  isMobile,
  moments,
  getTranslatedTheme,
  filteredContacts = [],
  visibleContactIds = []
}) => {
  const baseColumns = [
    {
      field: "quoi",
      headerName: isMobile ? "🛒" : t("What"),
      minWidth: 220,
      /*width: 250,*/
      flex: 1, // s'étire, laisse respirer le libellé 1 avant
      editable: false,

      renderCell: (params) => {
        const rowcolor = params.row.color || "transparent"; // 👈 couleur de la ligne
        const { label, colorTag } = params.row.quoi;

        console.log("🔥 quoi =", params.row.quoi); 

        const icon =
            colorTag === "boisson" ? "🥤" :
            colorTag === "custom"  ? "🛠️" :
            colorTag === "apero"   ? "🍹" :
            "🍽️";

        return (
         
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            height: "100%",
            backgroundColor: rowcolor,   // 👈 applique la couleur à toute la cellule
            borderRadius: 1,
            pl: 1,
          }}
        >
          <Tooltip title={label} arrow>
            <Box
              sx={{
                px: 1,
            py: "2px",
            borderRadius: "4px",
            fontWeight: 600,
            backgroundColor: "transparent",
            color:
              colorTag === "boisson" ? "#5d9fddff" :
              colorTag === "custom"  ? "#a58c55ff" :
              "inherit",
          whiteSpace: "nowrap",        // ← UNE SEULE LIGNE
          overflow: "hidden",          // ← cache le surplus
          textOverflow: "ellipsis",    // ← ajoute "…"
          maxWidth: "100%",            // ← limite à la largeur de la colonne
          cursor: "default",      
          }}
        >
          {icon} {label}
        </Box>
        </Tooltip>
        </Box>
    );
  },
    },
    {
      field: "quantite",
      headerName: isMobile ? "🔢" : t("Quantity"),
      width: 70,
      minWidth: 64,
      maxWidth: 84,
      align: "center",
      headerAlign: "center",
      editable: false,
      cellClassName: (params) => {
        const quantite = parseFloat(params.value);
        const pris = parseFloat(params.row.pris);
        const valid = !isNaN(quantite) && !isNaN(pris) && pris >= quantite;

        return `sticky-quantite ${valid ? "cell-valid" : ""}`;
      }
    },
    {
      field: "pris",
      headerName: isMobile ? "✔️" : t("Taken"),
      width: 70,
      minWidth: 64,
      maxWidth: 84,
      align: "center",
      headerAlign: "center",
      editable: false,
      cellClassName: (params) => {
        const quantite = parseFloat(params.row.quantite);
        const pris = parseFloat(params.value);
        const valid = !isNaN(quantite) && !isNaN(pris) && pris >= quantite;

        return valid ? "cell-valid" : "";
      }
    }
  ];
  logDev("[buildColumns] colonnes de base construites", baseColumns);

  const contactColumns = filteredContacts.map((c) => {
    const col = {
    field: `contact_${c._id}`,
    headerName: c.nom,
    minWidth: 120,
    width:130,
    flex: 0,        // a 1 avant 0 pour eviter le saut
    editable: true, // ✅ suffit pour activer l’édition au clic
    renderCell: (params) => (
      <Box 
        sx={{ 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "space-between",
        }}
      >
      <span>{params.value}</span>
      <span style={{ opacity: 0.6 }}>✏️</span> {/* petite icône à gauche */}
    </Box>
  ),
  // ✅ affichage en mode édition
  renderEditCell: (params) => (
      <GridEditInputCell
        {...params}
        inputProps={{
          ...params.inputProps,
          onFocus: (e) => e.target.select(), // ✅ sélection auto du texte
        }}
      />
    ),
  };

  logDev("[buildColumns] colonne contact générée", col);
  
  return col;
});

  const colonnesFiltrees =
    visibleContactIds.length > 0
      ? contactColumns.filter((col) =>
          visibleContactIds.includes(col.field.replace("contact_", ""))
        )
      : contactColumns;

  logDev("[buildColumns] colonnes filtrées", { visibleContactIds, colonnesFiltrees });

  const allColumns = [...baseColumns, ...colonnesFiltrees];
  logDev("[buildColumns] colonnes finales retournées", allColumns);
  return allColumns;
};